import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/Main";
// import { component } from "vue/types/umd";

Vue.use(Router);
const routes = [
  {
    path: "/",
    component: Main
  }
];
const router = new Router({
  routes,
  mode: "history",
    // base: '/screen/',
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js